import ButtonsField from './component';
import { ButtonsFieldProps } from './types';

export type { ButtonsFieldProps };
export default ButtonsField;
